import React from 'react';
import cn from 'classnames';
import {Call} from '@store/call-card/Call';
import {createStyles, withStyles} from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import {CommentIcon} from '@components/icon/CommentIcon';
import {HighlightIcon} from '@components/icon/HighlightIcon';
import {ScorecardIcon} from '@components/icon/ScorecardIcon';
import './CallActivity.sass';
import {FileUploadState} from 'records/FileUploadState';

interface CallActivityProps {
  call: Call;
}

export const CallActivity: React.FC<CallActivityProps> = ({call}) => {
  const commentCount = call.rawFields.get('Comments', []).length;
  const highlightCount = call.rawFields.get('Highlights', []).length;

  if (call.state.toLowerCase() === FileUploadState.METADATA_ONLY) {
    return (
      <div className="call-activity">
        <ActivityBadge count={call.scorecardResults}>
          <div className="live-coaching-tag">Live Coaching Call</div>
        </ActivityBadge>
      </div>
    );
  }

  return (
    <div className="call-activity">
      <ActivityBadge count={commentCount}>
        <CommentIcon tooltip="Number of comments" />
      </ActivityBadge>
      <ActivityBadge count={highlightCount}>
        <HighlightIcon tooltip="Number of highlights" />
      </ActivityBadge>
      <ActivityBadge count={call.scorecardResults}>
        <ScorecardIcon tooltip="Number of scorecard results" />
      </ActivityBadge>
    </div>
  );
};

const ActivityBadge = ({count, children}) => (
  <StyledBadge className={cn('badge', {active: count > 0})} badgeContent={count}>
    {children}
  </StyledBadge>
);

const StyledBadge = withStyles(theme =>
  createStyles({
    badge: {
      padding: '2px',
      height: 16,
      minWidth: 16,
      top: -2,
      right: -2,
    },
  })
)(Badge);
